import resourcesToBackend from "i18next-resources-to-backend";

import type { i18n } from "i18next";

export const attachResourcesBackend = (instance: i18n) => {
  instance.use(
    resourcesToBackend(
      (language: string, namespace: string) =>
        import(`../../../public/locales/${language}/${namespace}.json`),
    ),
  );
};
